import { render, staticRenderFns } from "./diagram-header.vue?vue&type=template&id=b51e6dcc&scoped=true"
import script from "./diagram-header.vue?vue&type=script&lang=js"
export * from "./diagram-header.vue?vue&type=script&lang=js"
import style0 from "./diagram-header.vue?vue&type=style&index=0&id=b51e6dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51e6dcc",
  null
  
)

export default component.exports